import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import theme from "./theme/theme";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ManageCompanies from "./pages/ManageCompanies";
import MyLayout from "./layout/MyLayout";
import PrivateRoute from "./components/PrivateRoute";
import Users from "./pages/Users";
import ManageJobDescriptions from "./pages/ManageJobDescriptions";
import HrLayout from "./layout/HrLayout";
import HRDashboard from "./pages/HRDashboard";
import NotFoundPage from "./pages/NotFoundPage";
import CandidateApplicationForm from "./pages/CandidateApplicationForm"; // Import the component
import LinkedInCallback from "./pages/LinkedInCallback";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Public Route for Candidate Application Form */}
          <Route
            path="/availablejobs/:formId"
            element={<CandidateApplicationFormWrapper />}
          />

          {/* Other routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" />} />

          {/* Protected Routes for Admin */}
          <Route element={<PrivateRoute allowedRoles={["Admin"]} />}>
            <Route
              path="/dashboard"
              element={
                <MyLayout>
                  <Dashboard />
                </MyLayout>
              }
            />
            <Route
              path="/companies"
              element={
                <MyLayout>
                  <ManageCompanies />
                </MyLayout>
              }
            />
            <Route
              path="/users"
              element={
                <MyLayout>
                  <Users />
                </MyLayout>
              }
            />
            <Route
              path="/manage-job-descriptions"
              element={
                <MyLayout>
                  <ManageJobDescriptions />
                </MyLayout>
              }
            />
          </Route>

          {/* Protected Routes for HR */}
          <Route element={<PrivateRoute allowedRoles={["HR", "hr"]} />}>
            <Route
              path="/hr-dashboard"
              element={
                  <HRDashboard />
              }
            />
          </Route>
          <Route path="/linkedin/callback" element={<LinkedInCallback />} />


          {/* Fallback Route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

// Wrapper component to extract formId from URL and pass it to CandidateApplicationForm
const CandidateApplicationFormWrapper: React.FC = () => {
  const { formId } = useParams<{ formId: string }>();

  if (!formId) {
    return <div>Form ID is missing.</div>;
  }

  return (
    <CandidateApplicationForm
      formId={formId}
      onSuccess={() => {
        console.log("Application submitted successfully!");
      }}
    />
  );
};

export default App;